import styled from "styled-components"

interface TabProps {
    readonly isActive: boolean
}

const Tab = styled.button<TabProps>`
    flex-grow: 1;
    height: 40px;
    border: 0;

    width: calc(100% / 3);

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 16px;
    line-height: 19px;

    color: ${props => props.isActive ? 'inherit' : '#606060'};
    background: ${props => props.isActive ? '#FFFFFF' : '#E3E6E6'};

    cursor: pointer;
    transition: background .2s;

    &:hover {
        background: #FAFAFA;
    }

    &:first-child {
        border-radius: 8px 0 0 0;
    }
    &:last-child {
        border-radius: 0 8px 0 0;
    }
`

export default Tab